import mixpanel, { Mixpanel } from "mixpanel-browser";

// Extend Mixpanel type to include __loaded
interface ExtendedMixpanel extends Mixpanel {
  __loaded?: boolean;
}

// Environment and token setup
const environment = process.env.REACT_APP_ENVIRONMENT;
// const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
const isProduction = environment === "production";

// Utility to check if Mixpanel is initialized
export const isMixpanelInitialized = (): boolean => {
  const mp = mixpanel as ExtendedMixpanel;
  return typeof mp !== "undefined" && !!mp.__loaded;
};
// Stricter user properties interface
interface UserProperties {
  name?: string;
  email?: string;
  createdAt?: string;
  avatar?: string | boolean; // Removed boolean to align with Mixpanel expectations
  uuid?: string | number; // Prefer string for user IDs
  paying?: boolean;
  plan?: string;
  [key: string]: any; // Allow additional properties
}

export const MixpanelAnalytics = {
  identify(userId: string, userProperties: UserProperties = {}) {
    if (!isMixpanelInitialized() || !isProduction) {
      console.warn("Mixpanel not initialized or not in production");
      return;
    }
    if (!userId) {
      console.warn("User ID is required for identify");
      return;
    }

    try {
      mixpanel.identify(userId);
      const userProfile: Record<string, any> = {
        $name: userProperties.name,
        $email: userProperties.email,
        $created: userProperties.createdAt, // Align with Mixpanel's $created
        $avatar: userProperties.avatar,
        ...userProperties,
      };
      mixpanel.people.set(userProfile);
    } catch (error) {
      console.error("Mixpanel identify error:", error);
    }
  },

  trackPageView(page: string, properties: Record<string, any> = {}) {
    if (!isMixpanelInitialized() || !isProduction) {
      console.warn("Mixpanel not initialized or not in production");
      return;
    }
    try {
      mixpanel.track("page_view", { page, ...properties }); // Align with useLogPageView
    } catch (error) {
      console.error("Mixpanel page view error:", error);
    }
  },

  trackEvent(eventName: string, properties: Record<string, any> = {}) {
    if (!isMixpanelInitialized() || !isProduction) {
      console.warn("Mixpanel not initialized or not in production");
      return;
    }
    try {
      mixpanel.track(eventName, { ...properties });
    } catch (error) {
      console.error("Mixpanel track error:", error);
    }
  },

  //   trackAuthEvent(
  //     eventType: "signup" | "login" | "logout",
  //     properties: Record<string, any> = {}
  //   ) {
  //     if (!isMixpanelInitialized() || !isProduction) {
  //       console.warn("Mixpanel not initialized or not in production");
  //       return;
  //     }
  //     try {
  //       const eventName = eventType.charAt(0).toUpperCase() + eventType.slice(1); // e.g., "Signup"
  //       mixpanel.track(eventName, { ...properties });
  //     } catch (error) {
  //       console.error(`Mixpanel ${eventType} error:`, error);
  //     }
  //   },

  reset() {
    if (!isMixpanelInitialized() || !isProduction) {
      console.warn("Mixpanel not initialized or not in production");
      return;
    }
    try {
      mixpanel.reset();
    } catch (error) {
      console.error("Mixpanel reset error:", error);
    }
  },
};
